import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgLockClosedIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 9h14v11H5zM8 6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v3H8V6Z"
    />
    <circle cx={12} cy={14} r={2.25} stroke="currentColor" strokeWidth={1.5} />
    <path
      d="M12 17v1"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgLockClosedIcon);
const Memo = memo(ForwardRef);
export default Memo;
